import React from 'react';
import Modal from 'react-bootstrap/Modal';
import close from "../../assets/svgs/close.svg";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useState, useEffect, useRef } from 'react';
import "../../assets/css/modal.css";
import PropTypes from "prop-types";
import "../../assets/css/component.css";
import { useForm } from "react-hook-form";
import PopUp from './Popup';
import { turnOffButton, turnOnButton } from "./buttonFunctions"
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { updatePassword } from '../../actions/userActions';
import { logoutUser } from '../../actions/authActions';

const ChangePassword = (props) => {
  const { register, reset } = useForm();
  const [password_current, setCurrPassword] = useState("");
  const [password_new, setNewPassword] = useState("");
  const [password_confirm, setCfmPassword] = useState("");
  const [popupTxt, setPopupTxt] = useState("");
  const [lshow, setLshow] = useState(false);

  const buttonElement = useRef(null)
  if (localStorage.headers) {
    var login = JSON.parse(window.localStorage.getItem('headers'))
    var userid = login.data.user.user_id
    var usertoken = login.data.token;
  }

  useEffect(() => {
    turnOffButton(buttonElement.current);
    if (password_current === "" || password_new === "" || password_confirm === "") {
      turnOffButton(buttonElement.current);
    }

    else if (password_new === password_confirm) {
      turnOnButton(buttonElement.current);
    }
  }, [password_new, password_confirm, password_current])

  useEffect(() => {
    if (props.user.updatePassword) {
      const response = props.user.updatePassword.data
      if (response.message === "Current password does not match!") {
        setPopupTxt("Current password does not match!");
        setLshow(true);
      } else if (response.message === "Password successfully changed!") {
        setCurrPassword("");
        setNewPassword("");
        setCfmPassword("");
        // setPopupTxt("Password updated successfully!");
        reset();
        toast.success("Password updated successfully! Please log in again.");
        setTimeout(() => {
          props.closeModal();
          props.logoutUser();
        }, 1500);
      } else if (response.message === "Please use the different password!") {
        setPopupTxt("Please use different password!");
        setLshow(true);
      }
    }

  }, [props.user.updatePassword]);

  function handleSubmit(event) {
    event.preventDefault();

    const data = {
      id: userid,
      current_password: password_current,
      password: password_new,
    };
    props.updatePassword(data);
  }

  return (
    <>
      <PopUp
        text={popupTxt}
        show={lshow}
        closeModal={() => setLshow(false)}
      />
      <Modal
        show={props.show}
        onHide={props.closeModal}
        dialogClassName="modal-md md"
        contentClassName="md"
        centered
      >
        <form onSubmit={handleSubmit}>
          <Modal.Body className=" px-5 py-4">
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={props.closeModal}
            >
              <img src={close} width="20" alt="close" />
            </button>
            <div style={{ marginBottom: '5%' }} className="text-center mt-5">
              <div className="back-heading">Change password</div>
              <div className="mt-5">
                <div className="input-title mb-3">Current password</div>
                <div className="mb-2">
                  <input
                    type="password"
                    className="form-control-lg input input-full"
                    minLength="7"
                    {...register("CurrentPassword")}
                    required
                    autoComplete="off"
                    onChange={(event) => { setCurrPassword(event.target.value) }}
                  />
                </div>
              </div>
              <div className="mt-5">
                <div className="input-title mb-3">New password</div>
                <div className="mb-2">
                  <input
                    type="password"
                    minLength="7"
                    className="form-control-lg input input-full"
                    required
                    {...register("NewPassword")}
                    autoComplete="off"
                    onChange={(event) => { setNewPassword(event.target.value) }}
                  />
                </div>
              </div>
              <div className="mt-4">
                <div className="input-title mb-3">Confirm password</div>
                <div className="mb-2">
                  <input
                    type="password"
                    className="form-control-lg input input-full"
                    minLength="7"
                    required
                    {...register("ConfirmPassword")}
                    autoComplete="off"
                    onChange={(event) => { setCfmPassword(event.target.value) }}
                  />
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="modal-footer no">
            <button
              className="btn btn-block btn-danger font-weight-bold py-3 rounded f18"
              type="submit" ref={buttonElement} disabled style={{ opacity: 0.5 }}
            >
              {" "}
              Submit
              <img src="images/log-out.svg" className="ml-2" alt="" />
            </button>
            <div className="powered my-4 w-100">Powered by Warely</div>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  )
}

ChangePassword.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user
})

export default withTranslation()(
  connect(mapStateToProps, {
    updatePassword,
    logoutUser
  })(ChangePassword)
);